import React from "react"

import SEO from "../../components/shared/SEO"
import TitleSection from "~components/pages/pims/specific/title"
import HowItWorksSection from "~components/pages/pims/specific/how-it-works"
import { IMPROMED_COPY } from "~components/pages/pims/resources/impromed"
import BenefitsExplanation from "~components/pages/pims/specific/benefits-explanation"

export default function ImpromedPage() {
    return (
        <>
            <TitleSection copy={IMPROMED_COPY} />
            <BenefitsExplanation copy={IMPROMED_COPY} />
            <HowItWorksSection copy={IMPROMED_COPY} />
        </>
    )
}

export const Head = () => <SEO title="Covetrus ImproMed/Infinity Integration" />
